import useToast from '@/components/Toast/useToast';

import { useSessionClusterJobUpdateMutation } from './useSessionClusterJobs';

export const useUpdateClusterJobName = (
  sessionId?: string,
  clusterJobId?: string,
  onError?: () => void
) => {
  const { createToast } = useToast();
  const { trigger } = useSessionClusterJobUpdateMutation(
    sessionId ?? '',
    clusterJobId ?? '',
    {
      onError: (error) => {
        onError?.();
        createToast({
          title: 'Error updating cluster job name',
          description: error.message,
          type: 'error',
        });
      },
    }
  );

  return trigger;
};
